import Lottie from 'react-lottie';
import React from 'react';

const LottiePlayer = React.memo(
    ({
        lottieRef,
        animationData,
        autoplay = true,
        loop,
        ...rest
    }: {
        lottieRef?: any;
        animationData: any;
        loop?: boolean;
        autoplay?: boolean;
    }) => {
        const defaultOptions = {
            loop: loop === false ? false : true,
            autoplay: autoplay,
            controls: false,
            animationData: JSON.parse(JSON.stringify(animationData)),
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice',
            },
        };

        return <Lottie ref={lottieRef} options={defaultOptions} {...rest} />;
    },
    (prevProps, nextProps) => {
        return (
            prevProps.animationData === nextProps.animationData &&
            prevProps.loop === nextProps.loop
        );
    },
);

export default LottiePlayer;
export { LottiePlayer };
